<template>
  <div class="asc-open-maintenance-grid">
    <asc-ag-grid-filter
      :key="`asc-open-maintenance-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
  AscAgGridDateFloatFilter,
  AscErrorTypeIconCellRenderer,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFormattedDateTime } from '@/utilities/dates'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscFlightDeckEffectsGrid',

  components: {
    AscAgGridFilter,
    AscAgGridAutocompleteFloatFilter,
    AscAgGridDateFloatFilter,
    AscErrorTypeIconCellRenderer,
    AscTooltipCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  data() {
    return {
      updateDateFieldName: 'timeStamp',
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        getContextMenuItems: this.getContextMenuItems,
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values.map(item => {
        return {
          ...item,
          code: item.code.toString(),
        }
      })
    },
    agGridRowData() {
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: this.getColumnTitle(
            this.gridColumns,
            'errorType',
            'Type',
          ),
          field: 'errorType',
          cellRenderer: 'AscErrorTypeIconCellRenderer',
          hide: !this.isColumnVisible(this.gridColumns, 'errorType'),
        },
        {
          headerName: this.getColumnTitle(this.gridColumns, 'code', 'Code'),
          field: 'code',
          hide: !this.isColumnVisible(this.gridColumns, 'code'),
        },
        {
          headerName: this.getColumnTitle(
            this.gridColumns,
            'timeStamp',
            'Time Stamp',
          ),
          field: 'timeStamp',
          width: 155,
          minWidth: 155,
          sort: 'desc',
          valueFormatter: data => getFormattedDateTime(data.value),
          comparator: this.sortDate,
          hide: !this.isColumnVisible(this.gridColumns, 'timeStamp'),
        },
      ]
    },
  },

  watch: {
    values() {
      this.handleRefreshColWidths()
    },
  },

  methods: {
    getContextMenuItems() {
      const result = ['copy', 'copyWithHeaders', 'export']

      return result
    },
  },
}
</script>

<style lang="scss">
.asc-maintenance-grid {
  .asc-sort-icon {
    color: $primary_black;
    position: absolute;
    top: 14px;
    right: 16px;
  }

  .asc-filter-icon {
    color: $primary_black;
  }

  .asc-grid-wrapper-header--container {
    .asc-grid-wrapper-header-buttons--container {
      .row {
        .col:first-child {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
